import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GlobeIcon, LockIcon, ShieldIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabelSystem, packageContents, trackCheckout } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-carbon-graphite" data-id="element-203" data-mp="1j979355ddc59">
      <div className="max-w-3xl mx-auto" data-id="element-204" data-mp="1nasq92oxscl9">
        <div className="text-center mb-12" data-id="element-205" data-mp="1n9r3i0yk61np">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-white" data-id="element-206" data-mp="1s9n6pxzflp27">
            Your complete <span className="text-gold" data-id="element-207" data-mp="1x8qdpnyz25ct">6-in-1 offer</span> today
          </h2>
          <p className="text-mist text-sm md:text-base" data-id="element-208" data-mp="1x6ndkb43uvud">
            The complete teaching system — ready for your next class.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3
      }} className="border-2 border-gold rounded-3xl p-1 relative" data-id="element-209" data-mp="2vh1vpiye7re">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-carbon font-bold px-5 py-1.5 rounded-full uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-210" data-mp="1hpy9zzx61aqp">
            <SparklesIcon size={14} data-id="element-211" data-mp="17rsatq2quipj" /> Complete System · Full Access
          </div>
          <div className="bg-carbon rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-212" data-mp="17ppc8hnizh97">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-3" data-id="element-213" data-mp="25er9g6czy0q2">
              Brazilian Jiu Jitsu Coach Ready —{' '}
              <span className="text-gold" data-id="element-214" data-mp="1vh30ocik2sow">Complete 6-in-1 Teaching System</span>
            </h3>
            <p className="text-base text-mist mb-8" data-id="element-215" data-mp="1rfri2qy3n7q7">
              Everything you need to teach Brazilian Jiu Jitsu with confidence.
            </p>

            <ul className="text-left max-w-xl mx-auto mb-8 divide-y divide-carbon-line border-y border-carbon-line" data-id="element-216" data-mp="k3r5sr4rxkev">
              {packageContents.map(row => <li key={row.label} className="flex items-start gap-3 py-3 text-sm" data-id="element-217" data-mp="hh8dnojt6nct">
                  <CheckIcon size={16} className="text-gold shrink-0 mt-0.5" data-id="element-218" data-mp="mgkv1trwv280" />
                  <span className="text-mist" data-id="element-219" data-mp="mei7dge8dl6g">{row.label}</span>
                </li>)}
            </ul>

            <div className="mb-8" data-id="element-220" data-mp="ciev3hpo065s">
              <span className="text-lg text-ash line-through block mb-1" data-id="element-221" data-mp="chn82va4vgr4">$105.00 USD</span>
              <div className="flex items-baseline justify-center gap-3" data-id="element-222" data-mp="3uvmtm0lkieh9">
                <span className="text-2xl md:text-3xl text-white font-semibold" data-id="element-223" data-mp="3hqjetnquhw2">TODAY:</span>
                <span className="text-5xl md:text-6xl font-extrabold text-gold" data-id="element-224" data-mp="3kyqhzm0dhc8h">$27.00</span>
                <span className="text-xl text-gold font-bold" data-id="element-225" data-mp="3pxl00lqimwrj">USD</span>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-3" data-id="element-226" data-mp="3by24qtiszfwn">
              {ctaLabelSystem}
            </Button>
            <p className="text-xs text-mist mb-5" data-id="element-227" data-mp="2xd7gtfdxniho">One-time payment · No subscriptions</p>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-smoke mb-4" data-id="element-228" data-mp="2sdut6sf8m7e1">
              <span className="flex items-center gap-1.5" data-id="element-229" data-mp="36d2t5nj85jja">
                <LockIcon size={12} className="text-cta" data-id="element-230" data-mp="31cf3p6an9ar6" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-231" data-mp="3g95vate2ti68">
                <ZapIcon size={12} className="text-cta" data-id="element-232" data-mp="3g7mhrajt1l85" /> Immediate access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-233" data-mp="3b91qi0mj6bvu">
                <ShieldIcon size={12} className="text-cta" data-id="element-234" data-mp="3p0zhowgadn3q" /> 7-day guarantee
              </span>
            </div>

            <div className="border border-carbon-line rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-235" data-mp="3l17e6y5r2758">
              <GlobeIcon className="text-gold shrink-0 mt-0.5" size={14} data-id="element-236" data-mp="2sq4dyjnd9u7" />
              <p className="text-[11px] text-smoke leading-snug" data-id="element-237" data-mp="3u2x582vpz42h">
                Pay in your local currency. The amount adjusts automatically
                based on the country you purchase from.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}